import React from "react"
import { Chart as ChartJS, registerables } from "chart.js"
import ChartDataLabels from "chartjs-plugin-datalabels"
import { Bar } from "react-chartjs-2"
import { useTranslation } from "react-i18next"
import { useSelector } from "react-redux"
import { Card } from "reactstrap"
import { layoutModeTypes } from "../../../../constants/layout"
import Colors from "../../../../constants/Colors"
import clockIcon from "../../../../assets/images/icons/flowbite_clock-outline_Dark.svg"

ChartJS.register(...registerables, ChartDataLabels)

const colors = {
  enrolled: "#00788D",
  present: "#B0D0B6",
  absent: "#AE6262",
}

const TrialOperationsActualChartsV2 = ({ shiftData }) => {
  const { t, i18n: {language}} = useTranslation()
  const layoutMode = useSelector(state => state.Layout.layoutModeType)

  const shiftLabels = {
    N: { label: t("Night Shift"), duration: t("(01:00 - 07:00)") },
    E: { label: t("Early Shift"), duration: t("(07:00 - 16:00)") },
    L: { label: t("Late Shift"), duration: t("(16:00 - 01:00)") },
  }

  const createChartData = stations => {
    const labels = stations.map(s => s.station.ab_name)
    const enrolled = stations.map(s => s.total_enrolled)
    const present = stations.map(s => s.total_present)
    const absent = stations.map(s => s.total_absent)

    return {
      labels,
      datasets: [
        {
          label: t("Enrolled"),
          data: enrolled,
          backgroundColor: colors.enrolled,
        },
        {
          label: t("Present"),
          data: present,
          backgroundColor: colors.present,
        },
        {
          label: t("Absent"),
          data: absent,
          backgroundColor: colors.absent,
        },
      ],
    }
  }

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      datalabels: {
        anchor: "end",
        align: "top",
        // color: "#ffffff",
        font: {
          weight: "bold",
        },
        formatter: Math.round,
      },
      legend: {
        position: "bottom",
        labels: {
          // color: "#ffffff",
          font: {
            size: 14,
          },
        },
      },
    },
    scales: {
      y: {
        beginAtZero: true,
        ticks: {
          color: "#767676",
        },
        border:{dash: [4, 4]},
        grid: {
          color: 'rgba(0, 120, 141, 0.21)', // for the grid lines

        },

      },
      x: {
        ticks: {
          // color: "#ffffff",
          font: {
            size: 14,
          },
          maxRotation: 0, // 👈 no rotation
          minRotation: 0, // 👈 no rotation
        },
        grid: {
          display: false,
        },
      },
    },
  }

  return (
    <div style={{ display: "flex", flexWrap: "wrap", gap: "20px" }}>
      {shiftData.map((shift, index) => (
        <Card
          style={{ border: "1px solid #D6D6D6", padding: "20px", flex: index === 0 ? "0 0 100%" : "0 0 calc(50% - 10px)", }}
          key={shift.shift_name}
        >
          <div className="d-flex align-items-center gap-2">
            <img   width={26}
                   height={26}
                   src={clockIcon} alt="Clock" />
            <h3 className="mt-2 font-bold">{shiftLabels[shift.shift_name].label}</h3>
          </div>
          <p
            style={{
              paddingLeft: language !== "en" ? 0 : "30px",
              paddingRight: language !== "en" ? "30px" : 0,
              color:
                layoutMode === layoutModeTypes.LIGHT
                  ? Colors.mutedBlue
                  : Colors.white,
            }}
            className="mb-4"
          >
            {shiftLabels[shift.shift_name].duration}
          </p>
          <div
            key={shift.shift_name}
            style={{
              borderRadius: "10px",
              paddingTop: "20px",
              height: "400px",
            }}
            className="mb-4"
          >
            <Bar data={createChartData(shift.stations)} options={options} />
          </div>
        </Card>
      ))}
    </div>
  )
}

export default TrialOperationsActualChartsV2
